import { Box } from "@mui/material";
import { EmployeesList } from "./EmployeesList";
import { PermissionsList } from "./PermissionsList";
import { RolesList } from "./RolesList";

export const UsersPermissions = () => {
  //TODO Порефакторить на общий компонент

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: { xs: 3, sm: 4, md: 6, lg: 10 },
        mt: 12,
        width: "100%",
      }}
    >
      <Box sx={{ flex: "1 1 320px", minWidth: 280, maxWidth: 500 }}>
        <EmployeesList />
      </Box>

      <Box sx={{ flex: "1 1 320px", minWidth: 280, maxWidth: 500 }}>
        <RolesList />
      </Box>

      <Box sx={{ flex: "1 1 320px", minWidth: 280, maxWidth: 500 }}>
        <PermissionsList />
      </Box>
    </Box>
  );
};
